import { Attachment } from 'types';

interface DefaultValuesAdapterReturn {
  title: string;
  description: string;
  images: Attachment[];
  docs: Attachment[];
  videos: Attachment[];
}

export function defaultValuesAdapter(): DefaultValuesAdapterReturn {
  return {
    title: '',
    description: '',
    images: [],
    docs: [],
    videos: [],
  };
}
